module.exports = __webpack_public_path__ + "media/images/admin/icons/thumbs-down-8cb75e3f948a06c4fd4ee1eab977ef86.svg";